export default function CSingleLineComments() {
  return <h2>C Single Line Comments</h2>;
}
